import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {PlatformLocation} from "@angular/common";
import {IAppConfigurationResponse} from "../../api/models/response/appConfiguration.response";
import {ToastService} from "../../@admin/services/message/toast.service";

@Injectable({
  providedIn: 'root'
})
export class AppConfigurationService {

  appConfigFileUrl: string = 'assets/appConfig/appConfiguration.json';
  appConfig: IAppConfigurationResponse = {};

  constructor(private httpClient: HttpClient, private _platformLocation: PlatformLocation, public _toast: ToastService) {
  }

  getConfig(): () => Promise<boolean> {
    return () => {
      return new Promise<boolean>((resolve) => {
        const appUrl: string = this.getBaseHref();
        const appBaseUrl = this.getDocumentOrigin() + appUrl;
        this.getAppConfigDetails(appBaseUrl, () => {
          resolve(true);
        })
      })
    };
  }

  getAppConfigDetails(appRootUrl: string, callback: () => void): void {
    this.httpClient
      .get(appRootUrl + this.appConfigFileUrl)
      .subscribe({
        next: (response: IAppConfigurationResponse): void => {
          if (response && Object.keys(response).length) {
            this.appConfig = response;
            callback();
          } else {
            this._toast.error({
              summary: 'Not Found',
              detail: 'Encountered error while retrieving data from config.'
            });
          }
        }, error: () => {
          callback();
          setTimeout(() => {
            this._toast.error({
              summary: 'Not Found',
              detail: 'Encountered error while retrieving data from config.'
            });
          }, 1000)
        }
      });
  }

  private getDocumentOrigin(): string {
    if (!document.location.origin) {
      const port: string = document.location.port ? ':' + document.location.port : '';
      return (document.location.protocol + '//' + document.location.hostname + port);
    }
    return document.location.origin;
  }

  private getBaseHref(): string {
    const baseUrl: string = this._platformLocation.getBaseHrefFromDOM();
    if (baseUrl) {
      return baseUrl;
    }

    return '/';
  }
}
